import request from '../../utils/request';

const PREFIX = '[VIRTUOUS]';

export const FETCH_VIRTUOUS_API_KEYS_REQUEST = `${PREFIX} FETCH_VIRTUOUS_API_KEYS_REQUEST`;
export const FETCH_VIRTUOUS_API_KEYS_SUCCESS = `${PREFIX} FETCH_VIRTUOUS_API_KEYS_SUCCESS`;
export const FETCH_VIRTUOUS_API_KEYS_FAILURE = `${PREFIX} FETCH_VIRTUOUS_API_KEYS_FAILURE`;

export const POST_VIRTUOUS_API_KEY_REQUEST = `${PREFIX} POST_VIRTUOUS_API_KEY_REQUEST`;
export const POST_VIRTUOUS_API_KEY_SUCCESS = `${PREFIX} POST_VIRTUOUS_API_KEY_SUCCESS`;
export const POST_VIRTUOUS_API_KEY_FAILURE = `${PREFIX} POST_VIRTUOUS_API_KEY_FAILURE`;

export const DELETE_VIRTUOUS_API_KEY_REQUEST = `${PREFIX} DELETE_VIRTUOUS_API_KEY_REQUEST`;
export const DELETE_VIRTUOUS_API_KEY_SUCCESS = `${PREFIX} DELETE_VIRTUOUS_API_KEY_SUCCESS`;
export const DELETE_VIRTUOUS_API_KEY_FAILURE = `${PREFIX} DELETE_VIRTUOUS_API_KEY_FAILURE`;

const fetchVirtuousApiKeysRequest = () => ({
  type: FETCH_VIRTUOUS_API_KEYS_REQUEST,
});

const fetchVirtuousApiKeysSuccess = payload => ({
  payload,
  type: FETCH_VIRTUOUS_API_KEYS_SUCCESS,
});

const fetchVirtuousApiKeysFailure = payload => ({
  payload,
  type: FETCH_VIRTUOUS_API_KEYS_FAILURE,
});

const postVirtuousApiKeyRequest = () => ({
  type: POST_VIRTUOUS_API_KEY_REQUEST,
});

const postVirtuousApiKeySuccess = payload => ({
  payload,
  type: POST_VIRTUOUS_API_KEY_SUCCESS,
});

const postVirtuousApiKeyFailure = payload => ({
  payload,
  type: POST_VIRTUOUS_API_KEY_FAILURE,
});

const deleteVirtuousApiKeyRequest = () => ({
  type: DELETE_VIRTUOUS_API_KEY_REQUEST,
});

const deleteVirtuousApiKeySuccess = () => ({
  type: DELETE_VIRTUOUS_API_KEY_SUCCESS,
});

const deleteVirtuousApiKeyFailure = payload => ({
  payload,
  type: DELETE_VIRTUOUS_API_KEY_FAILURE,
});

export const fetchVirtuousApiKeys = organizationUuid => dispatch => {
  dispatch(fetchVirtuousApiKeysRequest());

  return request
    .get(`/v1/integrations/virtuous/api-keys/?organization=${organizationUuid}`)
    .then(({ data }) => {
      dispatch(fetchVirtuousApiKeysSuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(fetchVirtuousApiKeysFailure(data));

      throw data;
    });
};

export const postVirtuousApiKey = (organizationUuid, params) => dispatch => {
  dispatch(postVirtuousApiKeyRequest());

  return request
    .post(`/v1/integrations/virtuous/api-keys/?organization=${organizationUuid}`, params)
    .then(({ data }) => {
      dispatch(postVirtuousApiKeySuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(postVirtuousApiKeyFailure(data));

      throw data;
    });
};

export const deleteVirtuousApiKey = organizationUuid => dispatch => {
  dispatch(deleteVirtuousApiKeyRequest());

  return request
    .delete(`/v1/integrations/virtuous/api-keys/?organization=${organizationUuid}`)
    .then(({ data }) => {
      dispatch(deleteVirtuousApiKeySuccess());

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(deleteVirtuousApiKeyFailure(data));

      throw data;
    });
};
